module.exports = __webpack_public_path__ + "static/task-management-85df848f0967c95a6feac79cc34d60bb.png";